import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-rss-icon',
  templateUrl: './communication-rss.component.html'
})
export class CommunicationRSSComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
